import http from '@/utils/http'

const create = ({ data }) => http()
  .post(`/links`, data)

const remove = ({ id }) => http()
  .delete(`/links/${id}`)

export default {
  create,
  remove
}



// WEBPACK FOOTER //
// ./src/api/link.js